import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Terms/Terms.tsx");
